export default __webpack_public_path__ + "static/media/darwer.86f94270.svg";